import React, { useContext } from 'react';
import styled from 'styled-components';
import { DynamicPanel } from './DynamicPanel';
import { CaseDetailsContext } from '../providers/CaseDetailsProvider';

const CaseSummaryPanelLayout = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px;
  background: ${({ theme }) => theme.colors.Snow};
  padding: 0.5rem;
  min-width: 15rem;
  max-width: 15rem;
  box-shadow: rgba(35, 47, 62, 0.1) 0px 0px 8px;
`;

const CaseSummaryPanel = () => {
  const { ddmAttributes } = useContext(CaseDetailsContext);
  if (!ddmAttributes?.caseSummarySchema) {
    return null;
  }

  return (
    <CaseSummaryPanelLayout>
      <DynamicPanel />
    </CaseSummaryPanelLayout>
  );
};

export { CaseSummaryPanel };
